import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { adminApi } from "../../services/api";
import { showToast } from "../../store/uiSlice";

const MissedCalls = () => {
  const dispatch = useDispatch();
  const { adminUser } = useSelector((state) => state.admin);
  const [callHistory, setCallHistory] = useState([]);

  // In a real implementation, you would fetch the call history from the backend.
  // For now, we'll use local storage or a placeholder.
  useEffect(() => {
    // Example: Fetch call history from backend if you have a route for it
    // adminApi.get("/calls/history").then(res => setCallHistory(res.data));
    
    // Fallback: load from local storage if saved
    const saved = localStorage.getItem("callHistory");
    if (saved) {
      try { setCallHistory(JSON.parse(saved)); } catch (e) {}
    }
  }, []);

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 p-5 border-b-2 border-[#e2e8f0] bg-[#f8fafc]">
        <div>
          <h2 className="font-syne text-xl font-extrabold text-[#0b1e33] uppercase tracking-tight">MISSED CALLS</h2>
          <p className="text-[11px] text-[#475569] font-mono font-extrabold mt-1 uppercase tracking-wider">{callHistory.length} CALL{callHistory.length !== 1 ? "S" : ""} LOGGED</p>
        </div>
      </div>

      <div className="p-5">
        {callHistory.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-20 h-20 rounded-2xl bg-[#f1f5f9] flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-phone-slash text-[#94a3b8] text-3xl" />
            </div>
            <p className="text-[#475569] font-syne font-extrabold text-base uppercase tracking-wider mb-1">NO CALLS YET</p>
            <p className="text-[#64748b] text-[11px] font-mono font-bold mt-1">Incoming calls will appear here.</p>
          </div>
        ) : (
          <div className="bg-white border-2 border-[#e2e8f0] rounded-xl overflow-hidden">
            <div className="divide-y divide-[#f1f5f9]">
              {callHistory.map((call) => (
                <div key={call.id} className="p-4 flex items-center justify-between hover:bg-[#f8fafc] transition-all">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${call.shortId ? 'bg-[#eff6ff] text-[#1e3a5f]' : 'bg-[#f1f5f9] text-[#94a3b8]'}`}>
                      <i className={`fas ${call.shortId ? 'fa-user' : 'fa-phone-slash'} text-sm`} />
                    </div>
                    <div>
                      <div className="font-syne text-sm font-extrabold text-[#0f172a]">{call.leadName}</div>
                      <div className="text-[10px] font-mono font-bold text-[#64748b] flex items-center gap-2 mt-0.5">
                        <span>{call.timestamp}</span>
                        {call.shortId && <span className="text-[#059669] bg-[#ecfdf5] px-1.5 py-0.5 rounded border border-[#a7f3d0]">#{call.shortId}</span>}
                      </div>
                    </div>
                  </div>
                  <div>
                    <span className={`text-[9px] font-mono font-extrabold uppercase px-2 py-1 rounded-lg ${call.shortId ? 'bg-[#ecfdf5] text-[#059669]' : 'bg-[#fef2f2] text-[#dc2626]'}`}>
                      {call.shortId ? 'Matched' : 'Unknown'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MissedCalls;